import type { GalleryProducts, GetProductsParams } from '@/types/catalog'
import * as apiBff from './bff'
import { createProductQueryParams } from './query-params'

export const PRODUCTS_PAGE_SIZE = 8

export async function getProducts<TGallery extends GalleryProducts = GalleryProducts>({
  season,
  department,
  subdepartments,
  families,
  viewMode,
  productCode,
  page = 0,
  size = PRODUCTS_PAGE_SIZE,
  filters = {},
  isNew,
  order,
}: GetProductsParams): Promise<TGallery> {
  const params = createProductQueryParams({
    department,
    families,
    subdepartments,
    filters,
    productCode,
    isNew,
  })

  params.set('page', page.toString())
  params.set('pageSize', size.toString())

  if (order) {
    params.set('order', order)
  }

  const rawProductsResponse = await apiBff.callBFF<TGallery>(
    'GET',
    `season/${season}/${viewMode === 'sm' ? 'super-models' : 'models'}?${params.toString()}`,
  )

  const products = Array.isArray(rawProductsResponse?.data) ? rawProductsResponse.data : []

  if (products.length === 0)
    return { ...rawProductsResponse, data: [] } as TGallery

  const normalizedProducts = products.map((product) => {
    return {
      ...product,
      review: product.review ?? { average_rating: 0, total: 0 },
    }
  })

  return {
    ...rawProductsResponse,
    data: normalizedProducts,
  } as TGallery
}
